import { useEffect, useState } from "react"
import TextArea from './textArea'
import BtnDelSvg from '../utils/btn-del-svg';
import style from '../task-creator.module.css'
import {ru} from "../../../data/ru";
import {by} from "../../../data/by";
export function Type1({change, id,deleteHandler, defaultValue}) {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

    const [text, setText] = useState(defaultValue?.name||'')
    const [percent, setPercent] = useState(defaultValue?.percent||0)

    function changeHandler(e) {
        e.target.tagName === 'INPUT' && setPercent(e.target.value)
        e.target.tagName === 'TEXTAREA' && setText(e.target.value)
    }

    useEffect(() => {
        const answer = {
            name: text,
            percent: percent
        }
        change(answer, id)
    }, [text, percent])

    return (
        <div className={style.task_line_box}>
            <h2>{language.answer}:</h2>
            <input defaultValue={defaultValue?defaultValue.percent:0} className={'taskcr-cr-answer-percent'} type="number"
                   onChange={(e) => changeHandler(e)}/>
            <h2>%</h2>
            <TextArea  changeHandler={changeHandler} value={text} placeholder={'Input answers'}/>
            <button className={style.task_answer_del} onClick={e => deleteHandler(id)}><BtnDelSvg/></button>
        </div>
    )
}